// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { TimeBaseEntity } from '../time-base-entity';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class TimeEntryStatus extends TimeBaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  description?: string;
}

